import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('TouchType crash', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6 dark:bg-zinc-950">
          <div className="surface max-w-md space-y-4 p-6 text-center">
            <h1 className="text-xl font-semibold text-strong">
              Noget gik galt
            </h1>
            <p className="text-sm text-muted">
              TouchType stødte på en uventet fejl. Prøv at genindlæse siden —
              din fremgang er gemt hvis du har konto eller har øvet for nylig.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-primary w-full"
            >
              Genindlæs siden
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
